export default "__VITE_ASSET__BHscFOeF__"